// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1uWMi","right":"styles_right__1s1PP"};